// Centralized admin-role checks — the same "admin or sysadmin" / "editor or admin
// or sysadmin" checks used to be re-typed inline across many files.
export const isAdminRole = (user) => user?.role === 'admin' || user?.role === 'sysadmin';
export const isContentRole = (user) => isAdminRole(user) || user?.role === 'editor';

// /admin/clickup is visible/usable ONLY to this one person (not a role — a specific
// account), both for the menu item and the page itself. Mirrored server-side in
// src/backend/routes/clickup.js so hiding the menu item is not the only guard.
export const CLICKUP_ALLOWED_EMAIL = 'arturas@buzkys.com';
export const canAccessClickUp = (user) => user?.email === CLICKUP_ALLOWED_EMAIL;
